/**
 * MUSKLE Bee Hive — partner referral → cart attribute (bee_hive_ref).
 * Uses MuskleBeeHivePartner when available; falls back to URL / legacy cookie / session.
 * Demo partner routes never write cart attribution — see DEMO_PARTNER_ROUTES in partner-state.js.
 */
(function () {
  'use strict';

  var ATTR = 'bee_hive_ref';
  var DEBOUNCE_MS = 400;

  function isDemoRoute() {
    return window.MuskleBeeHivePartner && window.MuskleBeeHivePartner.isDemoPartnerRoute();
  }

  function getPartnerRef() {
    if (isDemoRoute()) return '';
    if (window.MuskleBeeHivePartner) {
      var urlRef = window.MuskleBeeHivePartner.readUrlRef();
      if (urlRef) return urlRef;
      var active = window.MuskleBeeHivePartner.getActivePartner();
      if (active && active.ref) return active.ref;
    }
    if (isDemoRoute()) return '';
    try {
      var sp = new URLSearchParams(window.location.search);
      var a = sp.get('bee_hive_ref') || sp.get('ref') || sp.get('utm_partner');
      if (a && String(a).trim()) {
        var s = String(a).trim().toLowerCase().replace(/[^a-z0-9_-]/g, '');
        if (s) return s;
      }
    } catch (e) {
      /* ignore */
    }
    try {
      var ls = localStorage.getItem(ATTR);
      if (ls && String(ls).trim()) return String(ls).trim();
    } catch (e) {
      /* ignore */
    }
    try {
      return sessionStorage.getItem(ATTR) || '';
    } catch (e) {
      return '';
    }
  }

  function getCartUpdateUrl() {
    if (typeof window.Theme !== 'undefined' && window.Theme.routes && window.Theme.routes.cart_update_url) {
      return window.Theme.routes.cart_update_url;
    }
    return '/cart/update.js';
  }

  var debounceTimer = null;

  function syncCartAttribute() {
    debounceTimer = null;

    if (window.MuskleBeeHivePartner) {
      window.MuskleBeeHivePartner.syncFromPage();
    }

    var urlRef = '';
    if (window.MuskleBeeHivePartner) {
      urlRef = window.MuskleBeeHivePartner.readUrlRef();
    }

    var partnerRef = getPartnerRef();
    if (!partnerRef) return;

    fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart.js');
        return res.json();
      })
      .then(function (cart) {
        var attrs = cart && cart.attributes && typeof cart.attributes === 'object' ? cart.attributes : {};
        var existing = attrs[ATTR] != null ? String(attrs[ATTR]).trim() : '';

        if (existing === partnerRef) return;

        var merged = {};
        for (var k in attrs) {
          if (Object.prototype.hasOwnProperty.call(attrs, k)) {
            merged[k] = attrs[k];
          }
        }
        merged[ATTR] = partnerRef;

        return fetch(getCartUpdateUrl(), {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({ attributes: merged }),
        });
      })
      .catch(function () {
        /* silent */
      });
  }

  function scheduleSync() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(syncCartAttribute, DEBOUNCE_MS);
  }

  function bind() {
    syncCartAttribute();
    document.addEventListener('cart:update', scheduleSync);
    document.addEventListener('muskle-bee-hive-partner-changed', scheduleSync);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
